<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯2024年财报：To B营收2120亿元创新高，元宝日活增长超20倍</div>
      <div class="news-date">2025年3月20日</div>
      <div class="news-content">
        <div>
          <div class="image-panel" style="font-size: 0;">
            <img class="news-image" src="../img/newscenter/news71.gif"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_1.webp"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_2.gif"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_3.webp"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_4.gif"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_5.webp"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_6.gif"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_7.webp"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_8.gif"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_9.webp"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_10.webp"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_11.gif"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_12.webp"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_13.gif"/>
            <img class="news-image" src="../img/detail/Information/news71/news71_14.webp"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News71.vue